import React from 'react';
import { ReactComponent as Connector } from '../assets/greenconnector.svg';
import { get_apps } from '../../../api/api.js';

function Greenbox({ imageSrc, applink, keyno, applength, lastcheck}) {
  return (
    <div className="tile">
    <div className='Cardbox'>
      <div className="newYellow">
        <div className="whitebox">
          <div className='container'>
            <a target='_blank' href={applink}>
              <img className='applogo' src={imageSrc} alt="App Logo" />
            </a>
          </div>
        </div>
      </div>

      {/* {keyno != applength-1 && (
  <Connector className="greenconnector" />
)} */}

     
        <Connector className='greenconnector' style={{ visibility: keyno == applength-1 || keyno == lastcheck ?'hidden' : 'visible' }} />
        {console.log("lastvar",lastcheck)}
     
    </div>
    </div>
  );
}

export default Greenbox;
